module.exports = __webpack_public_path__ + "img/left.a522946a.png";